import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuCreatePayload,
	IActionMenuCreatePayloadDone,
	IActionMenuCreatePayloadError,
} from './types';

export const menuCreate = actionCreatorAsync<
	IActionMenuCreatePayload,
	IActionMenuCreatePayloadDone,
	IActionMenuCreatePayloadError
>(
	'menuCreate',
	async (params) => {
		const { menu } = params;
		const { data } = await Api.menu.create({
			body: menu,
		});

		return data;
	},
);
